<style lang="scss" scoped>
/deep/ {
  .swiper-pagination-bullets {
    display: flex;
    justify-content: center;
    bottom: 38px !important;
  }
  .swiper-pagination-bullet {
    width: 8px;
    height: 8px;
    background: #019cde;
    border-radius: 50%;
    margin: 0 5px !important;
    opacity: 1;
  }
  .swiper-pagination-bullet-active {
    width: 28px;
    background: #fff;
    border-radius: 10px;
  }
}

video {
  background: transparent url("~@/assets/images/video-cover.png") 50% 50%
    no-repeat;
  background-size: cover;
}

.rule {
  width: 350px;
  position: absolute;
  left: 50%;
  top: 10%;
  height: 80vh;
  transform: translate(-50%);
  background: #24447c;
  color: #fff;
  z-index: 1111;
  font-size: 10px;
  line-height: 20px;
  padding: 40px 0 40px 25px;
  .text {
    height: 100%;
    overflow: auto;
    padding-right: 25px;
  }
  .el-icon-close {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 24px;
  }
}
.catch {
  height: 100vh;
  overflow: hidden;
}

.btn {
  width: 230px;
  height: 36px;
  line-height: 36px;
  background: #24447c;
  color: #fff;
  font-size: 12px !important;
}
</style>

<template>
  <div :class="{ catch: rule }">
    <swiper ref="mySwiper" :options="swiperOptions2" class="mb50">
      <swiper-slide>
        <img src="@/assets/images/MObanner-1.jpg" class="w100" />
      </swiper-slide>
      <swiper-slide>
        <img src="@/assets/images/MObanner-2.jpg" class="w100" />
      </swiper-slide>
      <swiper-slide>
        <img src="@/assets/images/MObanner-3.jpg" class="w100" />
      </swiper-slide>
      <swiper-slide>
        <img src="@/assets/images/MObanner-4.jpg" class="w100" />
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>

    <div class="alignc mb15">
      <img src="@/assets/images/title.png" style="width: 90px" />
    </div>

    <div class="flex hcenter mb45">
      <img
        src="@/assets/images/quick-btn1.png"
        class="mr20 pointer"
        @click="go('block1')"
        height="114"
        width="82"
      />
      <img
        src="@/assets/images/quick-btn2.png"
        class="mr20 pointer"
        @click="go('block2')"
        height="114"
        width="82"
      />
      <img
        src="@/assets/images/quick-btn3.png"
        class="pointer"
        @click="go('block3')"
        height="114"
        width="82"
      />
    </div>

    <div class="alignc mb20" ref="block1">
      <img src="@/assets/images/MOpic-2.png" style="width: 340px" />
    </div>

    <div class="alignc mb40 font10" style="line-height: 30px">
      「希尔顿荣誉客会会员专享餐饮礼遇」
      <br />适用于大中华地区希尔顿集团旗下酒店*内参与活动的自营餐厅和酒吧，
      <br />且需会员出示有效会员身份证明。可能有优惠不适用日期，需提前致电确认。
      <br />上述礼遇适用于
      <span
        style="color: #0e4e97; text-decoration: underline"
        class="pointer"
        @click="rule = true"
        >活动细则及条款。</span
      >
    </div>

    <div class="alignc font12 mb20" style="color: #24447c; letter-spacing: 2px">
      还不是希尔顿荣誉客会会员？
    </div>

    <div class="alignc mb60">
      
        <img src="@/assets/images/m_qrcode.jpg" style="width: 230px"
      />
    </div>

    <div class="alignc mb20">
      <img src="@/assets/images/pic-3.png" style="width: 165px" />
    </div>

    <div class="alignc mb30" ref="block2">
      <video
        width="375"
        height="214"
        src="@/assets/tnm_video.mp4"
        controls="controls"
        poster="/static/column/video.png"
      ></video>
    </div>

    <div class="font10 alignc mb30" style="line-height: 25px">
      为相聚加码，希尔顿为你准备了
      <br />低至7.5折的餐饮折扣和餐饮消费积分奖励。
      <br />带上你的至亲挚友，一起来开桌！
    </div>

    <div class="alignc mb80">
      <img src="@/assets/images/m_pic-4.png" width="334" />
    </div>

    <div class="alignc">
      <img src="@/assets/images/pic-7.png" width="150" />
    </div>

    <div ref="block3" class="mb25">
      <hot />

      <div class="alignc">
        <a href="https://www.hilton.com.cn/" target="_blank">
          <img src="@/assets/images/MOmore_btn.jpg" alt="" width="230" />
        </a>
      </div>
    </div>

    <div class="alignc mb25">
      <img
        src="@/assets/images/m_rule-icon.png"
        width="75"
        @click="rule = true"
      />
    </div>

    <div class="rule-box mask fixed full" v-if="rule" catchtouchmove>
      <div class="rule">
        <i class="el-icon-close pointer" @click.stop="rule = false"></i>
        <div class="text">
          细则及条款
          <br />
          <br />此会员专享餐饮礼遇适用于 2020 年 10 月 28 日起至 2021 年 12 月 31
          日在大中华区（中国大陆、香港、澳门和台湾地区）希尔顿集团旗下酒店内参与活动的自营餐厅及酒吧的餐饮消费。酒店非自营餐厅及酒吧不提供希尔顿荣誉客会会员专享餐饮礼遇，请提前致电酒店，确认提供本礼遇的餐厅及酒吧）。
          <br />*澳门康莱德酒店与陵水碧桂园希尔顿逸林温泉酒店不参与本次会员专享餐饮礼遇活动。 
          <br />*大中华区
          Hampton by Hilton 希尔顿欢朋酒店 和 Home 2 Suites by Hilton
          希尔顿惠庭酒店不参与本次会员专享餐饮礼遇活动。
          <br />
          <br />入住会员与非入住会员的餐饮消费皆适用本会员专享餐饮礼遇，但不可和现有的其他会员餐饮礼遇、代金券或任何其他餐饮促销活动及餐饮计划同时使用。希尔顿荣誉客会会员在参与活动的餐厅及酒吧进行消费的，普通会员及银会籍会员可在不含适用的服务费、杂费等的实际消费金额（下称“实际消费金额”）的基础上享受
          10% 的折扣，金会籍会员及钻石会籍会员可在实际消费金额的基础上享受 25%
          的折扣。服务费和适用的杂费等以实际消费金额为基础收取。
          <br />
          <br />非入住会员或者预订非认可住宿的客人在餐厅进行消费的，实际消费金额满当地货币
          180元人民币或200港元/730新台币，可获赠餐饮“美味加分”500点希尔顿荣誉客会奖励积分，每张账单只可获赠1次
          500
          点奖励积分。预订认可住宿入住的会员可以把该次餐饮消费计入客房账单，以便累积希尔顿荣誉客会积分。详情请参考希尔顿荣誉客会适用条款。
          <br />
          <br />此礼遇仅适用于希尔顿荣誉客会会员。会员本人需在场用餐并支付账单，在结账前出示有效会籍等级证明，说明需要享受礼遇。无论该笔餐饮消费是否需要计入客房账单，若使用本礼遇，须在餐厅结算用餐消费金额前说明并出示有效会籍等级证明，不可在酒店前台处理。一个希尔顿荣誉客会的会员号在同一用餐时间段仅可享受一次礼遇。
          <br />
          <br />有效会籍等级证明指：（任选一种，截图无效）
          <br />
          <br />I. 希尔顿官方中英文手机应用 APP 中实时显示的会籍等级； <br />II.
          餐厅不提供查找会员身份信息服务，如果无法安装
          APP，可现场尝试通过希尔顿官方微信公众号客服验证身份（在【希尔顿Hilton】微信公众号菜单选择：会员专区
          > 在线客服 > 输入“人工客服” >
          输入“会籍等级”，根据提示回答验证问题来找回希尔顿荣誉客会会员号码和会籍等级）；
          <br />III.
          非会员可扫描酒店二维码或通过希尔顿荣誉客会中英文手机应用APP或希尔顿官方会员小程序注册会员，然后出示成功注册的页面，即可享受会员相应折扣；
          <br />IV.
          在【希尔顿Hilton】微信公众号领取希尔顿荣誉客会会员卡至微信卡包，点进“会籍”>
          “查看”以获取实时会籍等级。
          <br />餐厅有权酌情决定优惠不适用日期（例如国庆假期、圣诞节、元旦、农历新年、2
          月 14 日情人节等），需提前致电酒店餐厅确认适用日期。
          <br />
          <br />此会员专享餐饮礼遇不可用于早餐、客房点餐、客房迷你吧、各类宴会及会议用餐、十人以上包房、已订立合同的团体、活动以及于到会服务目的地举行的酒店外到会和餐饮服务，或特别促销套餐、外卖送餐、季节性菜单、节庆产品（如月饼、圣诞礼篮等）和烟草、鲜花、礼品等非餐饮类消费以及蛋糕费、小费等额外相关服务费。
          <br />
          <br />每组宾客／每张餐桌仅可使用一位会员的会员卡礼遇，且仅适用于包括会员本身在内的最多
          10
          位（含）成员的消费。礼遇不具备现金价值，不可出售或用于获取商业利益，并且不可转让。
          <br />
          <br />在法律允许的范围内，希尔顿酒店集团及参与此活动的酒店对本优惠活动有解释权。
          <br />
          <br />本次会员专享餐饮礼遇获赠积分需要 4 – 6
          周后方能在希尔顿荣誉客会帐户中显示。积分的赚取及兑换均受希尔顿荣誉客会会员适用条款的约束。点击了解完整会员条款及细则。
        </div>
      </div>
    </div>

    <div>
      <img src="@/assets/brands.jpg" class="w100" />
    </div>
  </div>
</template>

<script>
import hot from "@/components/hot_mo5";
export default {
  props: {},
  components: {
    hot,
  },
  computed: {},
  data() {
    return {
      rule: false,
      swiperOptions2: {
        loop: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
        },
      },
    };
  },
  mounted() {},
  methods: {
    go(block) {
      console.log(this.$refs[block]);
      let top = 700;
      if (block) {
        top = this.$refs[block].offsetTop - 180;
      }
      window.scrollTo({
        top,
        behavior: "smooth",
      });
    },
  },
};
</script>

